<template>
  <div class="function function-last" id="device">
    <h5>设备管理</h5>
    <div class="function-detail">
      <ul>
        <router-link tag="li" to="/revise_logon_password_validate">
          <i class="iconfont">&#xe60d;</i>
          <p>修改登录密码</p>
        </router-link>
        <router-link tag="li" to="/revise_pay_password_validate">
          <i class="iconfont">&#xe68e;</i>
          <p>修改支付密码</p>
        </router-link>
        <!-- <router-link tag="li" to="/change_tel">
          <i class="iconfont">&#xe608;</i>
          <p>更改手机绑定</p>
        </router-link> -->
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeDevice'
}
</script>

<style scoped>
.function-detail ul{ display: flex; justify-content: space-around; border-bottom: 12px solid #f1f1f1; font-size: 14px;}
.function h5{ margin: 10px 17px; font-size: 14px; font-weight: bold; font-family: 'Arial,Microsoft YaHei';}
.function-detail{ text-align: center;}
.function-detail .iconfont{ font-size: 25px;}
.function-detail p{ margin-top: 3px; color: #7e7979;}
.function-detail li{ margin-bottom: 10px; list-style-type: none; width: 33.33%;}
.function-last .iconfont{ color: #b2e946;}
</style>



// WEBPACK FOOTER //
// src/pages/me/components/Device.vue